import {gql} from 'apollo-angular';

export const SEARCH_SCHOOLS = gql`
  query searchSchools($searchText: String!) {
    searchSchools(searchText: $searchText) {
      id
      name
      url
    }
  }
`;
